import {ContactSearchOptionsRequest} from '../../../../shared/models/contactSearchOptionsRequest.model';

export class InvestingEntitySearchOptionsRequest extends ContactSearchOptionsRequest {
  contactId: number = null;
  withContactName = false;
  showHoldingRelatedInvestors = null;
  holdingId: number = null;
  distributionId: number = null;
}
